import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:"filterCarTeam"
    ,pure: false
})
export class FilterCarTeam implements PipeTransform {
    transform(items : any[],filter:string) {
        if(!items || !filter){
            return items;
        }

        return items.filter((val,idx) => {
            return val.dtgTeamId === filter;
        });
    }
}